// extracted by mini-css-extract-plugin
export default {"block":"paper-module__block__6QgWU","separator":"paper-module__separator__0ZEM7"};